<template>
    <NuxtLoadingIndicator color="rgb(var(--v-theme-primary)) !important" />
    <NuxtLayout v-bind:page-key="page.id">
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    const {
        $translations,
        $client
    } = useNuxtApp();

    // STORE REFS
    const {
        page
    } = storeToRefs($client);

    const {
        cartManager: manager
    } = $client;

    // Loading translations. Called once.
    await callOnce(async () => await $translations('$pipeline.app.general'));
</script>